import { render, staticRenderFns } from "./OVDetailView.vue?vue&type=template&id=07b40a87&lang=pug"
import script from "./OVDetailView.vue?vue&type=script&lang=js"
export * from "./OVDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports